<div #mainDiv [class.disabled]="homePageMask$()" style="position: relative">
    @if (banners()?.length) {
    <section #carouselDiv class="carousel-container" [id]="sectionId() || ''" [class]="sectionIdWithStyle()">
        <owl-carousel-o #carousel [options]="carouselOptions()">
            @for (banner of banners(); track trackByBannerId($index, banner); let i = $index) {
            @if (!banner.includes('hide-slider-banner')) {
            <ng-template carouselSlide>
                <div [innerHTML]="banner | safehtml"></div>
            </ng-template>
            }
            }
        </owl-carousel-o>
        <div [innerHTML]="navigationSection() | safehtml"></div>
    </section>
    }
    @if (productListSignal().length || productLoading()) {
    <section #carouselListDiv class="carousel-container product-list" [id]="sectionId() || ''" [class]="sectionIdWithStyle()">
        <div class="listing-container">
            @if (productLoading() && productListSignal().length === 0) {
            } @else {
            <owl-carousel-o #carouselList [options]="carouselListOptions()" [ngClass]="{
              'countdown-carousel': countDownTemplate() && countDownPresent(),
            }">
                @for (product of productListSignal(); track trackByProductId($index, product); let i = $index) {
                <ng-template carouselSlide>
                    @if ((countDownTemplate() && !!product?.deal) || showAddToCart()) {
                    <webstore-dynamic-home-product-card [productInput]="product" [showPercentageDiscount]="showPercentageDiscount()" [showCountdown]="countDownTemplate() && !!product?.deal" [showCashpoint]="showCashpoint()" [showAddToCart]="showAddToCart()" [baseHtml]="baseHtml()" (addToCartClicked$)="manageCarouselAutoPlay($event)" (productClicked$)="navigateToProductDetailPage(product.url_path)">
                    </webstore-dynamic-home-product-card>
                    } @else {
                    <div class="h-100" (click)="navigateToProductDetailPage(product.url_path)" [innerHTML]="
                      baseHtml() | interpolation: product : showCashpoint() : showPercentageDiscount() | safehtml
                    "></div>
                    }
                </ng-template>
                }
            </owl-carousel-o>
            <div [innerHTML]="carouselListNavigationSection() | safehtml"></div>
            }
        </div>
    </section>
    }

    <!-- Side Banner Product List -->
    @if ((collectionIds().length || categoriesInfo().length) && sideBannerProductList()) {
    <webstore-side-banner-product-list [showPercentageDiscount]="showPercentageDiscount()" [customOptions]="carouselListOptions()" [countDownTemplate]="countDownTemplate()" [showCashpoint]="showCashpoint()" [showAddToCart]="showAddToCart()" [sectionId]="sectionId()" [baseHtml]="baseHtml()" [carouselListNavigationSection]="carouselListNavigationSection()" [collectionIdsInput]="collectionIds()" [categoriesInfoInput]="categoriesInfo()" [sectionConfiguration]="sectionConfig()" (addToCartClicked$)="manageCarouselAutoPlay($event)" (productClicked$)="navigateToProductDetailPage($event)" (goToCollectionPage$)="navigateToCollectionPage($event)" (goToCategoryPage$)="navigateToCategoryPage($event)">
    </webstore-side-banner-product-list>
    }

    <!-- Multiple Collection Product List -->
    @if (collectionIds().length && !sideBannerProductList()) {
    <webstore-multiple-collection-product-list [showPercentageDiscount]="showPercentageDiscount()" [customOptions]="carouselListOptions()" [countDownTemplate]="countDownTemplate()" [showCashpoint]="showCashpoint()" [showAddToCart]="showAddToCart()" [sectionId]="sectionId()" [baseHtml]="baseHtml()" [carouselListNavigationSection]="carouselListNavigationSection()" [collectionIds]="collectionIds()" (addToCartClicked$)="manageCarouselAutoPlay($event)" (productClicked$)="navigateToProductDetailPage($event)"></webstore-multiple-collection-product-list>
    }

    <!-- Carousel layout section -->
    @if (carouselLayoutData().length) {
    <section #carouselLayoutDiv class="carousel-container carousel-layout" [id]="sectionId() || ''" [class]="sectionIdWithStyle()">
        <div class="carousel-card-layout-list">
            <div class="listing-container">
                <owl-carousel-o #carouselLayout [options]="carouselLayoutCustomOptions()">
                    @for (
                    carouselLayoutDatum of carouselLayoutData();
                    track trackByCarouselLayoutId($index, carouselLayoutDatum);
                    let i = $index
                    ) {
                    <ng-template carouselSlide>
                        <div class="h-100" [innerHTML]="
                    baseHtml()
                      | interpolation: carouselLayoutDatum : showCashpoint() : showPercentageDiscount()
                      | safehtml
                  "></div>
                    </ng-template>
                    }
                </owl-carousel-o>
                <div [innerHTML]="carouselLayoutNavigationSection() | safehtml"></div>
            </div>
        </div>
    </section>
    }

    <!-- Default Sections -->
    @if (normalContent()) {
    <div [innerHTML]="normalContent() | safehtml" #bannerSection></div>
    }

    <!-- Scrolling Text Layout -->
    @if (shouldShowScrollingText()) {
    <app-scrolling-text [banner]="componentBasedLayout()"></app-scrolling-text>
    }

    <!-- review layout section -->
    @if (shouldShowReviewLayout()) {
    <section class="carousel-container review-layout" [id]="sectionId() || ''" [class]="sectionIdWithStyle()">
        <div class="review-layout-list">
            <div class="listing-container">
                @if (layoutConfig()?.sectionTitle) {
                <h1 class="review-carousel-heading editable">
                    {{ layoutConfig()?.sectionTitle }}
                </h1>
                }
                @if (reviewsAverageRating()) {
                <div class="reviews-wrapper">
                    <div class="customer-review-detail">
                        <div class="google-logo-wrapper">
                            <img src="https://s3.ap-south-1.amazonaws.com/assets.hyperinvento.com/hyperinventory_admin/dynamic-home-assets/common/google-logo.svg" alt="Google" class="google-summary-icon" />
                        </div>
                        <div class="google-rating-info">
                            <p class="google-rating-score">{{ reviewsAverageRating() }}</p>
                            <div class="ratings non-editable">
                                <webstore-star-rating [rating]="reviewsAverageRating() || 0"></webstore-star-rating>
                            </div>

                            <p class="google-review-count" [ngClass]="{ 'url-style-handle': !reviewsPageUrl() }" (click)="openGoogleReviewPage()">
                                {{ reviewsTotalCount() }} Google reviews
                            </p>
                        </div>
                    </div>

                    <div class="inner-container">
                        <div class="review-block">
                            <owl-carousel-o #reviewLayout [options]="gReviewLayoutCustomOptions()">
                                @for (
                                googleReview of googleReviews();
                                track trackByReviewId($index, googleReview);
                                let i = $index
                                ) {
                                <ng-template carouselSlide>
                                    <div class="h-100" [innerHTML]="baseHtml() | reviewInterpolation: googleReview | safehtml" (click)="openGoogleReviewDetailOverlay(i)"></div>
                                </ng-template>
                                }
                            </owl-carousel-o>
                            @if (googleReviews().length > 1) {
                            <div [innerHTML]="carouselLayoutNavigationSection() || '' | safehtml"></div>
                            }
                        </div>
                    </div>
                </div>
                }
            </div>
        </div>
    </section>
    }

    <!-- for SSR use only -->
    @if (!isBrowser() && isCarouselDot()) {
    <div class="ssr-banner-adjustment"></div>
    }

    <!-- Angular 20: Use computed signal for loading state -->
    @if (shouldShowLoader()) {
    <webstore-card-loader></webstore-card-loader>
    }
</div>